import React from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { getFileLinks } from '../../../api/emailsApi/files';
import { changeAlertText } from '../../actions/index';
import { navigatingFolders } from '../../actions/folders';
import officeApi from '../../../api/officeApi';
import { handleDocrioAttachments, calculateAttachmentHash, isWindowsDesktop } from '../../utils/browser';
import * as RootActions from '../../actions/index';
import * as FileActions from '../../actions/files';
import { navigatingDocrioFiles } from '../../actions/files';
import axios from 'axios';
import { Buffer } from 'buffer/';
import './Attach.scss';

export const Attach = () => {
  const dispatch = useDispatch();
  const selectedFiles = useSelector((state) => state.files.selectedFiles);

  const formatAttachmentsForWeb = (responses) => {
    const docrioAttachments = {};
    responses.forEach((response) => {
      docrioAttachments[response.value] = response.id;
    });
    return docrioAttachments;
  };

  const formatAttachmentsForDesktop = async (responses) => {
    const docrioAttachments = {};
    await Promise.all(responses.map(async (response) => {
      const content = await officeApi.getAttachmentContent(response.value);
      const name = selectedFiles[response.id].name;
      const hash = calculateAttachmentHash(name, content.value.content);
      docrioAttachments[hash] = response.id;
    }));
    return docrioAttachments;
  };

  const onAttach = async () => {
    dispatch(RootActions.isLoading(true));
    let attachmentLinks;
    try {
      attachmentLinks = await getFileLinks(Object.keys(selectedFiles));
    } catch (e) {
      dispatch(changeAlertText('Failed to get file links', 'error'));
      dispatch(RootActions.isLoading(false));
      return;
    }
    const request = axios;
    request.defaults.withCredentials = false;
    const responses = await Promise.all(attachmentLinks?.Records?.map(async (record) => {
      let resp;

      if (isWindowsDesktop()) {
        const config = {
          method: 'GET',
          url: record.SignedUrlV2,
          responseType: 'arraybuffer',
        };
        const s3Response = await request(config);
        const base64String = Buffer.from(s3Response.data, 'binary').toString('base64');
        resp = await officeApi.putAttachmentContent(base64String, selectedFiles[record.Id].name);
      } else {
        resp = await officeApi.putAttachments(record.SignedUrlV2, selectedFiles[record.Id].name);
        dispatch(FileActions.attachedFiles({}));
      }
      return { ...resp, id: record.Id };
    }));

    // check for failures
    const failures = responses.filter((response) => response.status === 'rejected' || response.status === 'failed');
    batch(async () => {
      if (failures.length > 0) {
        console.log('FAILED TO ATTACH', failures);
        dispatch(changeAlertText(`One or more files failed to attach.`, 'error'));
      } else {
        const fileCount = Object.keys(selectedFiles).length;
        const alertText = `${fileCount} file${fileCount > 1 ? 's' : ''} successfully attached.`;
        dispatch(changeAlertText(alertText));
        // on web we can use graph ids but on desktop we need to calculate hashes.
        const docrioAttachments = isWindowsDesktop() ? await formatAttachmentsForDesktop(responses) : formatAttachmentsForWeb(responses);
        await handleDocrioAttachments(docrioAttachments);
      }
      dispatch(navigatingFolders(false));
      dispatch(navigatingDocrioFiles(false));
      dispatch(RootActions.isLoading(false));
    });
  };

  return (
    <div className='attach-component-container'>
      <div id='filesSelected' className='attach-component-files-selected'>
        Files Selected: {Object.keys(selectedFiles).length}
      </div>
      <div className='attach-component-button-container'>
        <button
          className='attach-component-button'
          onClick={onAttach}
          disabled={Object.keys(selectedFiles).length === 0}>
          Attach
        </button>
      </div>
    </div>
  );
};
